import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6218ccb4&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Unavailable: require('/app/components/Unavailable/Unavailable.vue').default,StepContact: require('/app/components/Checkout/StepContact/StepContact.vue').default,StepDelivery: require('/app/components/Checkout/StepDelivery/StepDelivery.vue').default,UIActionEntity: require('/app/data/UIActionEntity/UIActionEntity.vue').default,StepPayment: require('/app/components/Checkout/StepPayment/StepPayment.vue').default,OrderSummaryMobile: require('/app/components/Checkout/OrderSummaryMobile/OrderSummaryMobile.vue').default,Summary: require('/app/components/Checkout/Summary/Summary.vue').default,ErrorNote: require('/app/components/ErrorNote/index.vue').default,StepController: require('/app/components/Checkout/StepController/StepController.vue').default,CartProductList: require('/app/components/CartProductList/CartProductList.vue').default,AccessoriesProductCard: require('/app/components/AccessoriesProductCard/AccessoriesProductCard.vue').default,RowSliderNew: require('/app/components/sliders/RowSliderNew/RowSliderNew.vue').default,InfoBonus: require('/app/components/InfoBonus/InfoBonus.vue').default,CheckoutController: require('/app/components/Checkout/CheckoutController/CheckoutController.vue').default})
